import { render, staticRenderFns } from "./SpaPage.vue?vue&type=template&id=245b9f7e&scoped=true"
import script from "./SpaPage.vue?vue&type=script&lang=js"
export * from "./SpaPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/spa.css?vue&type=style&index=0&id=245b9f7e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b9f7e",
  null
  
)

export default component.exports